<div class="loader-container" *ngIf="!view">
    <app-loading-dots size="5px"></app-loading-dots>
</div>
<div class="course-select-list" *ngIf="view">
    <div class="right-buttom-menu">
        <p-button variant="text" (click)="courseListCsv()"  severity="link" >
            <i class="far fa-file-export"></i>
            <span style="padding-left: 5px"> {{'download_course_csv'|translation}} </span>
        </p-button>
    </div>
    <div>
        <app-view [items]="view?.data?.content" [info]="view?.data"></app-view>
    </div>
</div>

